import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthClient } from '../auth/AuthClient';
import Loading from '../components/Loading';
const AuthCallback = () => {
    const navigate = useNavigate();
    useEffect(() => {
        const returnTo = AuthClient.consumePendingReturnTo() ?? '/tools';
        void navigate(returnTo, { replace: true });
    }, [navigate]);
    return _jsx(Loading, { message: "Completing sign-in..." });
};
export default AuthCallback;
